
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 217.27 217.27"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M143.21 32.53l41.53 41.53 7.83-7.83-41.53-41.53zM27.49 148.14h12v14.81h14.82v14.82h14.81v12L177.76 81.05l-41.49-41.54zM212.85 24.5L192.78 4.42a15.11 15.11 0 00-21.05-.3c0 .05-.13.06-.19.11l-13.51 13.5 41.52 41.51 13.49-13.51c.06-.07.07-.15.14-.21a15.11 15.11 0 00-.33-21zM44.44 172.83H29.63v-14.81H19.06L0 217.27l59.27-19.06v-10.57H44.44z"}})])
          )
        }
      }
    